export default async function getSysParameters({ context, nextMiddleware }) {
  console.log('getSysParameters');
  try {
    await context.store.bankStore.getSysParameters();
    await context.store.bankStore.getSystemSetting();
    await context.store.envStore.getEnvLkk();
  } catch (e) {
    console.error(e);
    return context.next(false);
  }
  return nextMiddleware();
}
